import React from "react";
import { useFiltersDrawerContext } from "@pages/Dashboard/contexts/FiltersDrawer.context";
import styles from "./FiltersButton.module.scss";

const FiltersButton: React.FC = () => {
  const {
    onOpen,
    drawerFilters,
  } = useFiltersDrawerContext();

  const hasStatus = drawerFilters.status?.length > 0;
  const hasChannels = drawerFilters.channels?.length > 0;

  const hasActiveFilters = hasStatus || hasChannels;

  const buttonClass = hasActiveFilters
    ? `${styles.button} ${styles.active}`
    : styles.button;

  const handleClick = () => {
    onOpen?.();
  };

  return (
    <button type="button" className={buttonClass} onClick={handleClick}>
      Filtros
    </button>
  );
};

export default FiltersButton;
